// website/src/pages/oauthStyles.js
// Extracted styles from oauth.js for use in Auth and related components

const styles = {
  formContainer: { maxWidth: 600, margin: '12px auto', fontFamily: 'Inter, Segoe UI, Helvetica Neue, Arial, sans-serif', textAlign: 'center', background: '#fff', borderRadius: 8, boxShadow: '0 2px 12px rgba(0,0,0,0.07)', padding: '16px 20px' },
  header: {
    backgroundColor: '#282c34da',
    minHeight: '10vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 'calc(10px + 2vmin)',
    color: 'white',
    width: '100%',
    marginBottom: 0,
    fontFamily: 'Inter, Segoe UI, Helvetica Neue, Arial, sans-serif',
    letterSpacing: '0.5px',
  },
  headerTitle: {
    margin: 0,
    color: 'white',
    fontSize: 'calc(10px + 2vmin)',
    fontWeight: 500,
    fontFamily: 'Inter, Segoe UI, Helvetica Neue, Arial, sans-serif',
    letterSpacing: '0.5px',
    textTransform: 'none',
  },
  container: { maxWidth: 600, margin: '30px auto', fontFamily: 'Inter, Segoe UI, Helvetica Neue, Arial, sans-serif', textAlign: 'center', background: '#fff', borderRadius: 8, boxShadow: '0 2px 12px rgba(0,0,0,0.07)', padding: '20px 20px' },
  input: { width: '100%', padding: '10px 14px', margin: '8px 0', fontSize: 16, borderRadius: 6, border: '1px solid #ccc', fontFamily: 'Inter, Segoe UI, Helvetica Neue, Arial, sans-serif', letterSpacing: '0.2px' },
  providers: { display: 'flex', justifyContent: 'space-between', margin: '16px 0', gap: 12 },
  provider: { flex: 1, margin: '0 4px', padding: '10px', border: '1px solid #ccc', borderRadius: 4, background: '#f9f9f9', cursor: 'pointer', fontSize: 15, display: 'flex', alignItems: 'center', justifyContent: 'center', transition: 'background 0.2s, border 0.2s', fontFamily: 'Inter, Segoe UI, Helvetica Neue, Arial, sans-serif', fontWeight: 500, letterSpacing: '0.2px' },
  active: { borderColor: '#007bff', background: '#e7f1ff' },
  icon: { marginRight: 6, fontSize: 18 },
  icloudSection: { textAlign: 'left', background: '#f5f5f5', padding: 24, borderRadius: 8, marginTop: 24, marginBottom: 16, fontFamily: 'Inter, Segoe UI, Helvetica Neue, Arial, sans-serif', fontSize: 14 },
  instructions: { fontSize: 14, marginBottom: 16, lineHeight: 1.6, fontFamily: 'Inter, Segoe UI, Helvetica Neue, Arial, sans-serif', letterSpacing: '0.2px' },
  button: {
    width: '50%',
    padding: '12px 0',
    fontSize: 16,
    background: 'linear-gradient(90deg, #a7a9ac 0%, #bfc1c2 40%, #888a8c 100%)',
    color: '#181a1b',
    border: 'none',
    borderRadius: 8,
    cursor: 'pointer',
    margin: '0 auto',
    display: 'block',
    boxShadow: '0 4px 16px rgba(136,138,140,0.22), 0 1px 0 #fff inset',
    transition: 'transform 0.1s, box-shadow 0.1s',
    fontWeight: 600,
    letterSpacing: '0.5px',
    textShadow: '0 2px 8px rgba(136,138,140,0.16)',
    outline: 'none',
    fontFamily: 'Inter, Segoe UI, Helvetica Neue, Arial, sans-serif',
  },
  output: { width: '100%', minHeight: 120, padding: 10, marginTop: 20, fontSize: 15, borderRadius: 4, border: '1px solid #ccc', whiteSpace: 'pre-wrap', resize: 'none', fontFamily: 'Inter, Segoe UI, Helvetica Neue, Arial, sans-serif' },
  message: { width: '100%', padding: 10, marginTop: 20, fontSize: 15, whiteSpace: 'pre-wrap', textAlign: 'left', border: '1px solid #ccc', borderRadius: 4, background: '#f9f9f9', fontFamily: 'Inter, Segoe UI, Helvetica Neue, Arial, sans-serif' },
  success: { color: '#28a745', marginTop: 20 }
};

export default styles;
